import * as yup from 'yup';

export const loginFormSchema = yup.object({
  userName: yup.string().required(),
  password: yup.string().required(),
  remember: yup.boolean(),
})


export type LoginFormValues = yup.InferType<typeof loginFormSchema>